<template>
    <div class="ui-facilita-register-tasks-record-attendance">
        <section class="actions-tasks-attendance">
            <div
                class="attendance"
                :class="{ active: attendanceTasks }"
                @click="attendanceTasks = true"
            >
                <span class="text-attendance">Atendimento</span>
            </div>

            <div
                class="tasks"
                :class="{ active: !attendanceTasks }"
                @click="attendanceTasks = false"
            >
                <span class="text-tasks">Tarefas</span>

                <span class="notifications">{{ lengthDataTasks }}</span>
            </div>
        </section>

        <attendance-register
            v-if="attendanceTasks"
            @input="openIframe('register-attendance')"
        />

        <tasks-register
            v-else
            :customer-name="customerName"
            @input="openIframe('register-tasks')"
        />
    </div>
</template>

<script>
    import { alertMixin } from '@/mixins';
    import { mapActions, mapGetters } from 'vuex'
    import attendanceRegister from './attendance-register'
    import tasksRegister from './tasks-register'

    export default {
        name: 'register-attendance-tasks',

        components: {
            attendanceRegister,
            tasksRegister
        },

		mixins: [alertMixin],

        data() {
            return {
                attendanceTasks: true,
                dealId: undefined
            }
        },

        computed: {
            ...mapGetters('contractAttendanceTasks', {
                customerName: 'getCustomerName',
                lengthDataTasks: 'getLengthDataTasks'
            })
        },

        async mounted() {
            this.dealId = Number(this.$route.params.dealId)

            await this.fetchInitialCard()
        },

        methods: {
            ...mapActions('contractAttendanceTasks', ['getInitialCards']),

            async fetchInitialCard() {
                try {
                    this.getInitialCards(this.dealId)

                } catch (error) {
                    this.$mx_alertThisOnError(error)
                }
            },

            openIframe(value, data = null) {
                let event = new CustomEvent(`iframe--contracts-${value}`, { detail: data })
                window.parent.document.dispatchEvent(event)
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import 'styles.styl'
</style>